module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "7.215564a7.jpg";